import React, { useRef } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { newAuthService } from "Service/Axios";
import { UPDATE_COLUMN_URL } from "Constant/api";
import { useColumnList } from "Constant/apiHooks";
import { useOutsideClick } from "Utils/hooks";

export const Columns = ({
  show,
  projectid,
  toggle,
  onApplyColumnChanges,
  fetchApplicantHeaderList,
}) => {
  const { t } = useTranslation();

  const dragColumn = useRef();
  const dragOverColumn = useRef();
  const columnRef = useRef();

  const {
    columnList,
    setColumnList,
    duplicateColumnList,
    // loading: columnLoading,
  } = useColumnList(projectid);

  const handleToggleColumn = async (e, col, index) => {
    let newArr = [...columnList];
    newArr[index].show = e.target.checked;
    const payload = {
      projectId: projectid,
      projectType: "dashboard",
      fieldsetting: newArr,
    };
    await newAuthService(UPDATE_COLUMN_URL, "POST", payload);
    setColumnList(newArr);
    fetchApplicantHeaderList();
  };

  const handleSearchColumn = (e) => {
    let newArr = [...duplicateColumnList];
    if (e.target.value.length > 0) {
      const searchedColumn = newArr.filter((option) =>
        option.label.toLowerCase().includes(e.target.value.toLowerCase())
      );
      setColumnList(searchedColumn);
    } else {
      setColumnList(duplicateColumnList);
    }
  };

  const onColumnEditClick = (index) => {
    const newArr = columnList.map((col, cIndex) =>
      cIndex === index
        ? {
            ...col,
            makeEditable: true,
          }
        : {
            ...col,
            makeEditable: false,
          }
    );
    setColumnList(newArr);
  };

  const handleColumnInputChange = (e, index) => {
    let newArr = [...columnList];
    newArr[index].label = e.target.value;
    setColumnList(newArr);
  };

  const handleColumnKeyPress = async (e) => {
    if (e.key === "Enter") {
      const payload = {
        projectId: projectid,
        projectType: "dashboard",
        fieldsetting: columnList,
      };
      await newAuthService(UPDATE_COLUMN_URL, "POST", payload);
      const newArr = columnList.map((col) => ({
        ...col,
        makeEditable: false,
      }));
      setColumnList(newArr);
      onApplyColumnChanges();
    }
  };

  const dragStartColumn = (position) => {
    dragColumn.current = position;
  };

  const dragEnterColumn = (position) => {
    dragOverColumn.current = position;
  };

  const onDropColumn = async () => {
    const copyListItems = [...columnList];
    const dragItemContent = copyListItems[dragColumn.current];
    copyListItems.splice(dragColumn.current, 1);
    copyListItems.splice(dragOverColumn.current, 0, dragItemContent);
    dragColumn.current = null;
    dragOverColumn.current = null;
    setColumnList(copyListItems);
    const payload = {
      projectId: projectid,
      projectType: "dashboard",
      fieldsetting: copyListItems,
    };
    await newAuthService(UPDATE_COLUMN_URL, "POST", payload);
    fetchApplicantHeaderList();
  };

  const disableColumnEdit = () => {
    const newArr =
      columnList &&
      columnList.length > 0 &&
      columnList.map((col) => ({
        ...col,
        makeEditable: false,
      }));
    setColumnList(newArr);
  };
  useOutsideClick(columnRef, () => disableColumnEdit());

  return (
    <Modal
      show={show}
      onHide={toggle}
      className="modal text-start right modal-slider"
    >
      <Modal.Header closeButton className="px-3">
        <Modal.Title className="text-base font-medium text-slate-600">
          {t("auth.projects.editColumn.title")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ul className="list-unstyled">
          <li className="mb-2">
            <div className="search-div px-3">
              <div className="input-group">
                <input
                  type="search"
                  className="form-control"
                  placeholder={t("common.placeHolder.searchColoum")}
                  onChange={handleSearchColumn}
                />
                <button type="button" className="input-group-text">
                  <i className="pluto-search"></i>
                </button>
              </div>
            </div>
          </li>
          <li ref={columnRef}>
            <ul className="list-unstyled">
              {columnList &&
                columnList.length > 0 &&
                columnList.map((col, index) => (
                  <li className="filter-item" key={`${col.questionId}${index}`}>
                    <div
                      className="coloum-name px-3 d-flex align-items-center"
                      onDragStart={() => dragStartColumn(index)}
                      onDragEnter={() => dragEnterColumn(index)}
                      onDragEnd={onDropColumn}
                      draggable={index === 0 ? false : true}
                    >
                      <button className="btn-grag text-slate-500 border border-slate-100 bg-transparent">
                        <i className="bx bxs-grid-alt"></i>
                      </button>
                      <button
                        className="btn btn-edit text-slate-500"
                        onClick={() => onColumnEditClick(index)}
                      >
                        <i className="bx bxs-pencil"></i>
                      </button>
                      {col.makeEditable ? (
                        <input
                          type="text"
                          value={col.label}
                          onChange={(e) => handleColumnInputChange(e, index)}
                          onKeyDown={(e) => handleColumnKeyPress(e)}
                          className="form-control form-control-sm"
                        />
                      ) : (
                        <span className="text-sm font-medium text-slate-600">
                          {col.label}
                        </span>
                      )}
                      <div className="form-check form-switch form-check-success ms-auto">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          role="switch"
                          id="flexSwitchCheckDefault"
                          checked={col.show}
                          onChange={(e) => handleToggleColumn(e, col, index)}
                          disabled={index === 0}
                        />
                      </div>
                    </div>
                  </li>
                ))}
            </ul>
          </li>
        </ul>
      </Modal.Body>
    </Modal>
  );
};
